<template>
  <section class="ventana">
    <div class="container">
      <div class="saludo" id="saludo">¡Hola!</div>
      <div class="perrito" id="perrito"></div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {};
  },
  async mounted() {
    const perrito = document.getElementById("perrito");
    const saludo = document.getElementById("saludo");
    const container = document.querySelector(".ventana"); // Selecciona el contenedor
    let position = 0; // Posición inicial
    let direction = 1; // Dirección inicial (1 para derecha, -1 para izquierda)

    function moveDog() {
      position += 10 * direction; // Incrementa la posición según la dirección

      const perritoWidth = 100; // Ancho del perrito
      const containerWidth = container.clientWidth; // Ancho del contenedor

      // Verifica si el perrito ha llegado al borde derecho o izquierdo del contenedor
      if (position > containerWidth - perritoWidth) {
        direction = -1; // Cambia dirección a izquierda
        saludo.style.opacity = 0; // Oculta el saludo al chocar
        perrito.style.transform = "scaleX(-1)"; // Invierte la imagen
      } else if (position < 0) {
        direction = 1; // Cambia dirección a derecha
        saludo.style.opacity = 0; // Oculta el saludo al chocar
        perrito.style.transform = "scaleX(1)"; // Normaliza la imagen
      }

      perrito.style.left = position + "px"; // Actualiza la posición del perrito

      // Actualiza la posición del saludo para que esté siempre encima del perro
      saludo.style.left = position + (perritoWidth / 2 - 50) + "px"; // Centra el saludo sobre el perro
    }

    // Función para mostrar el saludo
    function showGreeting() {
      saludo.style.opacity = 1; // Muestra el saludo
    }

    // Inicia la animación
    moveDog();

    // Agrega un evento de clic al perrito
    perrito.addEventListener("click", () => {
      showGreeting(); // Muestra el saludo al hacer clic
    });

    setInterval(moveDog, 20); // Llama a moveDog cada 20 ms para animar continuamente
  },
};
</script>

<style lang="scss" scoped>
body {
  margin: 0;
  overflow: hidden; /* Evita el scroll */
  background-color: #87ceeb; /* Color de fondo del cielo */
}

.container {
  position: relative;
  width: 100%;
  height: 100vh; /* Altura completa de la ventana */
}

.perrito {
  position: absolute;
  width: 100px; /* Ancho del perrito */
  height: 60px; /* Alto del perrito */
  background-image: url("https://mir-s3-cdn-cf.behance.net/project_modules/disp/140946122639777.60ddc6d926363.gif"); /* Imagen del perrito */
  background-size: cover;
  bottom: 20px; /* Posición desde abajo */
}

.saludo {
  position: absolute;
  font-size: 24px;
  color: blue;
  bottom: 100px; /* Ajusta esta posición para estar encima del perro */
  left: calc(50% - 50px); /* Centra horizontalmente inicialmente */
  opacity: 0; /* Inicialmente oculto */
  transition: opacity 0.5s; /* Transición suave para la aparición */
}
</style>


// WEBPACK FOOTER //
// src/components/admin/varios/components/Pets.vue